import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import "./SystemManageWorkspaceLayout.scss";

/**
 * 系统管理工作台：仅承载子路由内容区（与剧集管理一致，导航由 HomeShell / 菜单承担，避免重复侧栏）。
 */
export const SystemManageWorkspaceLayout: FC = () => (
  <div className="system-manage-workspace system-manage-workspace--outlet-only system-manage-gray-scope">
    <Outlet />
  </div>
);
